<template>
  <div>
    <div class="countdown">
      <div class="_countdown">
        <div class="countdownDays countdownWrapper">
          <svg height="125" width="125" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="-12.75 -12.25 100 100" xml:space="preserve">
              <circle cx="37.5" cy="37.5" r="37" fill="#fff"></circle>
              <g>
                <path class="circleAnimation days" d="M39.6,5.3c16.8,1.1,30.2,15,30.2,32.2c0,17.8-14.4,32.2-32.2,32.2S5.2,55.3,5.2,37.4
                  c0-17.1,13.4-31.1,30.2-32.2" stroke-width="11" stroke="#FFD200" fill="#fff" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
          </svg>
          <div class="_countdownDays countdownNumber">{{countdownDays | two_digits}}</div>
          <div class="countdownLabel">Days</div>
        </div>
        <div class="countdownHours countdownWrapper">
          <svg height="125" width="125" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="-12.75 -12.25 100 100" xml:space="preserve">
              <circle cx="37.5" cy="37.5" r="37" fill="#fff"></circle>
              <g>
                <path class="circleAnimation hrs" d="M39.6,5.3c16.8,1.1,30.2,15,30.2,32.2c0,17.8-14.4,32.2-32.2,32.2S5.2,55.3,5.2,37.4
                  c0-17.1,13.4-31.1,30.2-32.2" stroke-width="11" stroke="#FFD200" fill="#fff" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
          </svg>
          <div class="_countdownHours countdownNumber">{{countdownHours | two_digits}}</div>
          <div class="countdownLabel">Hrs</div>
        </div>
        <div class="countdownMins countdownWrapper">
          <svg height="125" width="125" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="-12.75 -12.25 100 100" xml:space="preserve">
              <circle cx="37.5" cy="37.5" r="37" fill="#fff"></circle>
              <g>
                <path class="circleAnimation mins" d="M39.6,5.3c16.8,1.1,30.2,15,30.2,32.2c0,17.8-14.4,32.2-32.2,32.2S5.2,55.3,5.2,37.4
                  c0-17.1,13.4-31.1,30.2-32.2" stroke-width="11" stroke="#FFD200" fill="#fff" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
          </svg>
          <div class="_countdownMins countdownNumber">{{countdownMins | two_digits}}</div>
          <div class="countdownLabel">Mins</div>
        </div>
        <div class="countdownSecs countdownWrapper">
          <svg height="125" width="125" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="-12.75 -12.25 100 100" xml:space="preserve">
              <circle cx="37.5" cy="37.5" r="37" fill="#fff"></circle>
              <g>
                <path class="circleAnimation secs" d="M39.6,5.3c16.8,1.1,30.2,15,30.2,32.2c0,17.8-14.4,32.2-32.2,32.2S5.2,55.3,5.2,37.4
                  c0-17.1,13.4-31.1,30.2-32.2" stroke-width="11" stroke="#FFD200" fill="#fff" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
          </svg>
          <div class="_countdownSecs countdownNumber">{{countdownSecs | two_digits}}</div>
          <div class="countdownLabel">Secs</div>
        </div>
      </div>
    </div>
    <!-- <div id="countdownBarTimer" class="countdownBarTimer">
      <div class="countdownProgress" :style="{width: countdownProgress+'px' }"></div>
    </div> -->
    <!-- <div class="dayLeft">
      {{countdownDays}} Days Left!
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Countdown",
  props: {
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      countdownProgress: 0,
      countdownDays: 0,
      countdownHours: 0,
      countdownMins: 0,
      countdownSecs: 0,
    };
  },
  methods: {
    countdownInit() {
      var timer
      var now = new Date()
      var timeDiff = new Date(this.endDate).getTime() - now.getTime()
      var seconds = Math.floor(timeDiff / 1000)
      var minutes = Math.floor(seconds / 60)
      var hours = Math.floor(minutes / 60)
      var days = Math.floor(hours / 24)
      hours %= 24
      minutes %= 60
      seconds %= 60
      if (days < 0) {
        days = hours = minutes = seconds = 0
      }

      this.countdownDays = days
      this.countdownHours = hours
      this.countdownMins = minutes
      this.countdownSecs = seconds
      if (timeDiff <= 0) {
        clearTimeout(timer)
        return
      }
      timer = setTimeout(this.countdownInit, 1000)

      this.countdownAnimation(days, hours, minutes, seconds)
    },
    countdownAnimation(days, hours, minutes, seconds) {
        var initialOffsetSecs = 198.25 / 60
        var initialOffsetMins = 198.25 / 60
        var initialOffsetHrs = 198.25 / 24
        var initialOffsetDays = 198.25 / 365

        var daysPath = document.querySelector('.circleAnimation.days')
        var hrsPath = document.querySelector('.circleAnimation.hrs')
        var minsPath = document.querySelector('.circleAnimation.mins')
        var secsPath = document.querySelector('.circleAnimation.secs')

        daysPath.style.strokeDashoffset = ((365 - days) * initialOffsetDays).toString()
        hrsPath.style.strokeDashoffset = ((60 - hours) * initialOffsetHrs).toString()
        minsPath.style.strokeDashoffset = ((365 - minutes) * initialOffsetMins).toString()
        secsPath.style.strokeDashoffset = ((60 - seconds) * initialOffsetSecs).toString()
    }
  },
  filters:{
    two_digits(value){
      if(value.toString().length <= 1)
    {
        return "0"+value.toString()
    }
    return value.toString()
    }
  },
  mounted() {
    this.countdownInit()
  }
};
</script>

<style lang="scss" scoped>
$countdownSize: 300px;

.countdown {
  display: block;
  text-align: center;
  margin-top: 15px;
  @media only screen and (max-width: $sm) {
    margin-top: 55px;
  }
  ._countdown{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
  }

  .countdownWrapper {
    position: relative;
    text-align: center;
    height: 100px;
    min-width: 100px;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    @media only screen and (max-width: $sm) {
      height: 50px;
      min-width: 50px;
      margin-right: 50px;
    }

    &:last-child {
      margin-right: 0;
      padding-right: 0;

      .countdownNumber::after {
        display: none;
      }
    }

    svg {
      position: absolute;
      overflow: visible;
      path {
        stroke-dasharray: 198.25;
        transition: all 1s linear;
      }
    }

    .countdownNumber {
      font-family: 'UniversLTStd-BoldCn';
      font-size: 24px;
      color: $dark-blue;
      letter-spacing: 0;
      line-height: 32px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      &::after {
        position: absolute;
        right: -15px;
        top: 50%;
        transform: translateY(-50%);
        backface-visibility: hidden;
        font-size: 36px;
        color: $light-blue;
        letter-spacing: 0;
        line-height: 28px;
      }
    }

    .countdownLabel {
      font-family: 'UniversLTStd-Bold';
      font-size: 14px;
      line-height: 12px;
      color: $grey-blue;
      opacity: 0.5;
      text-transform: uppercase;
    }
  }
}
.countdownBarTimer {
  height: 1px;
  background: $dark-blue;
  max-width: $countdownSize;
  margin: 20px auto;
  position: relative;

  .countdownProgress {
    max-width: $countdownSize;
    background: $dark-blue;
    height: 5px;
    transition: width 0.5s ease-in-out;
    position: absolute;
    top: -2px;
  }
}
.dayLeft{
  font-size: 24px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  line-height: 24px;
}
</style>